import { Reveal, SectionHead } from "@/components/Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "Operational discipline",
    body: "Freight is a promise with a clock on it. Agaman runs on fixed dispatch windows, checked vehicles and drivers briefed before the wheels roll — not after something goes wrong.",
  },
  {
    n: "02",
    title: "Coverage without gaps",
    body: "From the industrial belts of the NCR to port-side warehouses in Chennai, our lanes connect the corridors where India actually makes and moves things.",
  },
  {
    n: "03",
    title: "Accountability on record",
    body: "Every consignment is tracked, documented and billed transparently. When you ask where your freight is, the answer is data — not a guess.",
  },
];

export const Manifesto = () => (
  <section id="about" data-testid="about-section" className="scroll-mt-20 py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-[1fr_1.6fr] gap-12 lg:gap-20">
      <div className="lg:sticky lg:top-28 self-start">
        <SectionHead
          overline="The Agaman Standard"
          title="Built like the freight we carry."
          sub="Agaman Freight is a pan-India trucking and warehousing operator. No noise, no slogans — just steady, verifiable movement of heavy freight across the country."
        />
      </div>

      <div className="flex flex-col divide-y divide-slate-800 border-y border-slate-800">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.12}>
            <div
              data-testid={`manifesto-chapter-${c.n}`}
              className="group grid sm:grid-cols-[100px_1fr] gap-4 sm:gap-8 py-10"
            >
              <span className="mono text-3xl font-semibold text-slate-700 group-hover:text-amber-500 transition-colors duration-300">
                {c.n}
              </span>
              <div>
                <h3 className="font-display text-xl sm:text-2xl font-bold uppercase tracking-wide text-slate-200">
                  {c.title}
                </h3>
                <p className="mt-3 text-base text-slate-400 leading-relaxed max-w-xl">
                  {c.body}
                </p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>

    <div className="max-w-7xl mx-auto px-5 sm:px-8 mt-16 grid sm:grid-cols-2 gap-px bg-slate-800 border border-slate-800">
      <Reveal>
        <div data-testid="mission-card" className="bg-[#161B22] p-8">
          <p className="mono text-[10px] uppercase tracking-[0.25em] text-amber-500 font-semibold">Mission</p>
          <p className="mt-3 text-lg text-slate-200 leading-relaxed">
            Move India's heavy freight with the reliability of infrastructure.
          </p>
        </div>
      </Reveal>
      <Reveal delay={0.1}>
        <div data-testid="vision-card" className="bg-[#161B22] p-8">
          <p className="mono text-[10px] uppercase tracking-[0.25em] text-amber-500 font-semibold">Vision</p>
          <p className="mt-3 text-lg text-slate-200 leading-relaxed">
            A logistics network where on-time is the default, not the exception.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
